import { addressFields, noNumbersFields } from "@is/constants/checkout";
import { InputTypes, SignUpInputFields } from "@is/types";
import { CheckoutInputFields } from "@is/types/checkout";

export const SEARCH_INPUT_TEXT_AND_NUMBERS =
  /[^a-zA-Z0-9 .!/@#$%^&*()_+-=;'"áéíóúüñÁÉÍÓÚÜÑàâæçèêëîïôœùûÿÀÂÆÇÈÊËÎÏÔŒÙÛŸäößÄÖãÕÿŸąćęłńśźżĄĆĘŁŃŚŹŻøåØÅčďěňřšťůČĎĚŇŘŠŤŮőűŐŰășțĂÎȘȚğışÇĞİŞðþÐÞìòÌÒ]/gm;

export const INPUT_EMAIL_REGEX =
  /^(?!.*\.\.)[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

export const INPUT_EMAIL = /[A-Za-z0-9._%+@-]/g;

export const INPUT_PHONE_NUMBER_REGEX = /[\d\s+()]/g;

export const INPUT_NUMBERS = /^[0-9]+$/;

export const INPUT_NOT_NUMBERS = /[^\d]/g;

export const INPUT_ADDRESS = /[a-zA-Z\u00c0-\u017e0-9\s'/\-,.]/g;

export const INPUT_LETTERS_NUMBERS = /[a-zA-Z\u00c0-\u017e0-9\s]/g;

export const INPUT_ZIP_CODE = /[0-9a-zA-Z -]/g;

export const NOT_BARCODE_SYMBOLS = /[^a-z^A-Z^0-9]/g;

export const INPUT_EMOJI = /\p{Extended_Pictographic}/gu;

export const validatePhoneNumber = (phoneNumber: string) =>
  phoneNumber.match(INPUT_PHONE_NUMBER_REGEX)?.join("") ?? "";

export const validateNotNumbers = (value: string) =>
  value.match(INPUT_NOT_NUMBERS)?.join("") ?? "";

export const stripEmojis = (value: string) => value.replace(INPUT_EMOJI, "");

export const validateCheckoutField = (
  fieldName: CheckoutInputFields | SignUpInputFields,
  fieldType: string,
  value: string
) => {
  if (fieldType === InputTypes.Tel) {
    return validatePhoneNumber(value);
  }

  if (noNumbersFields.includes(fieldName)) {
    return stripEmojis(validateNotNumbers(value));
  }

  if (addressFields.includes(fieldName as CheckoutInputFields)) {
    return value.match(INPUT_ADDRESS)?.join("") ?? "";
  }

  if (
    fieldName === CheckoutInputFields.Email ||
    fieldName === CheckoutInputFields.PhoneNumberOrEmail
  ) {
    return value.match(INPUT_EMAIL)?.join("") ?? "";
  }

  if (fieldName === CheckoutInputFields.ZipCode) {
    return (
      value.match(INPUT_ZIP_CODE)?.join("") ??
      value.substring(0, value.length - 1)
    );
  }

  return value;
};
